export const LOADING_COMMON_DATA = "LOADING_COMMON_DATA";
export const GET_COMMON_DATA = "GET_COMMON_DATA";
